import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { Bar } from 'react-chartjs-2';

export default function EpisodesPerYear() {
  const data = useStaticQuery(graphql`
    query {
      allEpisodesJson {
        group(field: fields___year) {
          totalCount
          fieldValue
          nodes {
            id
            duration
            fields {
              year
            }
          }
        }
      }
    }
  `);

  const years = data.allEpisodesJson.group;
  const chartData = {
    labels: years.map((year) => year.fieldValue),
    datasets: [
      {
        label: 'Episodes published',
        data: years.map((year) => year.totalCount),
        backgroundColor: ['#3b85f2'],
      },
    ],
  };

  const chartOptions = {
    indexAxis: 'y',
    scales: {
      x: {
        ticks: {
          color: '#d1d5db',
        },
        grid: {
          color: '#273045',
        },
      },
      y: {
        ticks: {
          color: '#d1d5db',
        },
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  return (
    <div>
      <h3 className="text-2xl">Episodes per year</h3>
      <div className="mt-5 w-max border border-gray-700 hover:border-gray-600 shadow-2xl rounded-md p-5">
        <Bar data={chartData} options={chartOptions} />
      </div>
    </div>
  );
}
